<template>
  <div class="collapse-foot">
    <sidebar-section
        sidebar-type="care-plan-generator-sidebar"
        :sidebar-id="sidebarUniqueIdx"
        sidebar-title="Care Plan"
        sidebar-icon="file-earmark-medical"
        :care-plan="carePlan"
        :profile="profile"
        :account-type="accountType"
        :root-path-doc="rootPathDoc"
    />
    <sidebar-section
        v-if="false"
        sidebar-type="registration-sidebar"
        :sidebar-id="sidebarUniqueIdx"
        sidebar-title="Registration"
        sidebar-icon="person-badge"
        :care-plan="carePlan"
    />
    <sidebar-section
        v-if="false"
        sidebar-type="notification-sidebar"
        :sidebar-id="sidebarUniqueIdx"
        sidebar-title="Notification"
        sidebar-icon="megaphone"
        :care-plan="carePlan"
    />
    <sidebar-section
        v-if="false"
        sidebar-type="sessions-sidebar"
        :sidebar-id="sidebarUniqueIdx"
        sidebar-title="Session"
        sidebar-icon="tv"
        :care-plan="carePlan"
        :profile="profile"
        @add-data-click="handleAddDataButtonClick"
    />
    <sidebar-section
        v-if="false"
        sidebar-type="insights-sidebar"
        :sidebar-id="sidebarUniqueIdx"
        sidebar-title="Insights"
        sidebar-icon="pie-chart"
        :care-plan="carePlan"
        :disabled="true"
    />
  </div>
</template>

<script>
import SidebarSection from "@/components/common/carePlanComponents/sidebBar";
export default {
  name: "CarePlan_Action_Buttons",
  components: {
    SidebarSection
  },
  props: {
    sidebarUniqueIdx: {
      type: Number,
      default: 0
    },
    carePlan: {
      type: Object,
      default: () => {
        return {};
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    accountType: {
      type: String,
      default: 'provider'
    },
    rootPathDoc: {
      type: String,
      default: null
    }
  },
  methods: {
    handleAddDataButtonClick(carePlan)
    {
      this.$emit('add-data-click', carePlan);
    }
  }
};
</script>

<style lang="scss" scoped>
.collapse-foot {
  display: flex;
  justify-content: flex-end;
}
</style>
